import { render, staticRenderFns } from "./UtsInfo.vue?vue&type=template&id=60d560f6&scoped=true&"
import script from "./UtsInfo.vue?vue&type=script&lang=js&"
export * from "./UtsInfo.vue?vue&type=script&lang=js&"
import style0 from "./UtsInfo.vue?vue&type=style&index=0&id=60d560f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d560f6",
  null
  
)

export default component.exports